import service from '@/utils/request'
// 获取零售客户列表
export function getcustomerlistApi(data) {
  return service.post(`pcustomer/customerlist`, data);
}

// 添加零售客户
export function addcustomerApi(data) {
  return service.post(`pcustomer/addcustomer`, data);
}

// 获取零售客户详情
export function getcustomerdetailApi(data) {
  return service.post(`pcustomer/customerdetail`, data);
}

//修改零售客户信息
export function editcustomerApi(data) {
  return service.post(`pcustomer/editcustomer`, data);
}
//删除零售客户
export function delcustomerApi(data) {
  return service.post(`pcustomer/delcustomer`, data);
}

// 零售客户户号列表
export function getcustomerlistnumApi(data) {
  return service.post(`pcustomer/customernumlist`, data);
}

// 添加户号
export function addcustomernumApi(data) {
  return service.post(`pcustomer/addcustomernum`, data);
}

// 获取户号详情
export function getcustomernumdetailApi(data) {
  return service.post(`pcustomer/customernumdetail`, data);
}

// 修改户号
export function editcustomernumApi(data) {
  return service.post(`pcustomer/editcustomernum`, data);
}